import { Outlet } from "react-router-dom";
import "../App.css";
import PWABadge from "../PWABadge";
import { NavbarDesktop } from "../components/navbarDesktop/navbarDesktop";
import { TopBar } from "../components/topBar/topBar";
import { LeftBarMobile } from "../components/leftBarMobile/leftBarMobile";
import { useLayout } from "./layout/useLayout";
import { clsx } from "clsx/lite";
import { ImpersonationBanner } from "../components/impersonationBanner/impersonationBanner";
import { NavbarMobile } from "@/components/navbarMobile/navbarMobile";

export default function Layout() {
  const { isTablet, leftBarMobileOpen, setLeftBarMobileOpen } = useLayout();

  return (
    <>
      <div className="flex flex-col h-screen w-screen">
        <ImpersonationBanner />
        {isTablet && <TopBar />}
        <div
          className={clsx(
            "flex",
            "flex-col",
            "tablet:flex-row",
            "space-between",
            "h-full",
            "tablet:h-[calc(100%-6rem)]",
          )}
        >
          {/* DESKTOP LEFT NAVBAR */}
          {isTablet ? (
            <div className="h-full border-r border-neutral">
              <NavbarDesktop />
            </div>
          ) : (
            <LeftBarMobile
              isOpen={leftBarMobileOpen}
              setIsOpen={setLeftBarMobileOpen}
            />
          )}
          <main
            className={clsx(
              "bg-canvas-primary",
              "overflow-y-scroll",
              "w-full",
              "flex",
              "flex-col",
              "grow",
              "tablet:min-h-full",
            )}
          >
            <Outlet />
          </main>
          {/* MOBILE BOTTOM NAVBAR */}
          {!isTablet && <NavbarMobile />}
        </div>
      </div>
      <PWABadge />
    </>
  );
}
